/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Update_ErrorInputs */

const en_notifications_update_error = /** @type {(inputs: Notifications_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not update notifications. Please try again.`)
};

const pl_notifications_update_error = /** @type {(inputs: Notifications_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się zaktualizować powiadomień. Spróbuj ponownie.`)
};

/**
* | output |
* | --- |
* | "Could not update notifications. Please try again." |
*
* @param {Notifications_Update_ErrorInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_update_error = /** @type {((inputs?: Notifications_Update_ErrorInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Update_ErrorInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_update_error(inputs)
	return en_notifications_update_error(inputs)
});